var React = require('react');

function DigitalExperience (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.8182 1.5H2.18182C0.981818 1.5 0 2.445 0 3.6V16.2C0 17.355 0.981818 18.3 2.18182 18.3H9.81818L8.04 20.8725C7.56 21.5655 8.07273 22.5 8.94545 22.5H15.0545C15.9273 22.5 16.4509 21.5655 15.96 20.8725L14.1818 18.3H21.8182C23.0182 18.3 24 17.355 24 16.2V3.6C24 2.445 23.0182 1.5 21.8182 1.5ZM21.8182 14.1H2.18182V4.65C2.18182 4.0725 2.67273 3.6 3.27273 3.6H20.7273C21.3273 3.6 21.8182 4.0725 21.8182 4.65V14.1Z"}));
}

DigitalExperience.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DigitalExperience;

DigitalExperience.default = DigitalExperience;
